import * as TYPE_ from '../actions_const/ui_const'
import { createAction } from 'redux-actions'

export const updateUiPanelProperties = createAction(
  TYPE_.EXCHANGE_PANEL_UI_PROPERTIES_UPDATE
)
